/* Marcel Afters · Sets engine v4 (G3d, WO v2, 2026-10-05).
   Data (assets/ma-sets-combos.json): {v:2, cdn, p:[{h,n,c,dc,v:[[variantId,size,priceCents,available]],f,w}],
     L:[{i,n,dn,a,t,b,img,pr,k,o,u,sh}]   full looks: a model wearing that exact outfit; u = the set page handle
     S:[{i,n,dn,a,o,t,b,pr,k,m}]          flat-lay sets; m = a model lead image (golden rule), never shown without it
     H:[...] shoes (true pairs on limestone, model on hover)}
   Pages: /collections/sets (+ sets-her / sets-him / sets-unisex): one grid with Her / Him / Unisex chips and colour + occasion filters.
          set page (page.set): look image first, both pieces with a size each, Add both pieces, matching shoes, more sets.
          home rails (rail-looks / rail-flats).
   Golden rule: every card leads with the model; the limestone pair of flats fades in on hover. */
(function () {
  'use strict';
  var SEG = { her: 'Her', him: 'Him', unisex: 'Unisex' };
  var SEGS = ['her', 'him', 'unisex'];
  var DOT = { Black: '#111317', White: '#ffffff', Gray: '#9aa0ab', Navy: '#1e2a4a', Brown: '#6b4a3a', Green: '#5b6b52', Blue: '#6f8fb5' };
  var LS = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };

  function el(tag, attrs, html) { var e = document.createElement(tag); if (attrs) for (var k in attrs) { if (attrs[k] != null) e.setAttribute(k, attrs[k]); } if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* Merchandising rule: never three in a row of the same top type or the same colour family. */
  function spread(items) {
    var out = [], rest = items.slice();
    function same(a, b, f) { return a[f] && a[f] === b[f]; }
    while (rest.length) {
      var pick = 0;
      for (var j = 0; j < rest.length; j++) {
        var s = rest[j].s, bad = false;
        if (out.length >= 2) { var a = out[out.length - 1].s, b = out[out.length - 2].s; if ((same(a, b, 'y') && same(a, s, 'y')) || (same(a, b, 'k') && same(a, s, 'k'))) bad = true; }
        if (!bad) { pick = j; break; }
      }
      out.push(rest.splice(pick, 1)[0]);
    }
    return out;
  }
  function plus() { return '<svg class="ds-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>'; }

  function Engine(root) {
    this.root = root;
    this.mode = root.dataset.mode || 'page';
    this.sheet = root.querySelector('[data-se-sheet]');
    this.body = root.querySelector('[data-se-body]');
    this.page = parseInt(root.dataset.page, 10) || 24;   /* 24 per page, then Show more */
    this.limit = parseInt(root.dataset.limit, 10) || 10;
    this.base = root.dataset.root || '';
    this.fmt = new Intl.NumberFormat(root.dataset.locale || document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency || 'USD' });
    this.load();
  }
  Engine.prototype.load = function () {
    var self = this;
    fetch(this.root.dataset.src, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (d) {
      self.d = d;
      self.items = self.build();
      if (self.mode === 'set') self.renderSet();
      else if (self.mode === 'page') self.renderGrid(self.root.querySelector('[data-se-host]'), { preset: self.root.dataset.preset, locked: self.root.dataset.locked === 'true', url: true });
      else self.renderRail();
    }).catch(function () {
      [].forEach.call(self.root.querySelectorAll('[data-se-host],[data-se-rail]'), function (g) { g.innerHTML = '<p class="ma-se__empty">Sets could not load. Browse <a href="' + self.base + '/collections/her">Her</a>, <a href="' + self.base + '/collections/him">Him</a> or <a href="' + self.base + '/collections/essentials-unisex">Unisex</a>.</p>'; });
    });
  };
  Engine.prototype.money = function (c) { var t = this.fmt.format(c / 100); return c % 100 === 0 ? t.replace(/[.,]00(?=\D*$)/, '') : t; };
  Engine.prototype.src = function (f, w) { if (!f) return ''; var u = /^(https?:)?\/\//.test(f) ? f : this.d.cdn + f; return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; };
  Engine.prototype.srcset = function (f, ws) { var self = this; return ws.map(function (w) { return self.src(f, w) + ' ' + w + 'w'; }).join(', '); };
  Engine.prototype.pdp = function (p, a) { return this.base + '/products/' + p.h + '?variant=' + p.v[0][0] + (a === 'her' || a === 'him' ? '&gender=' + a : ''); };  /* the PDP leads with the set's audience */
  Engine.prototype.price = function (s) { var d = this.d; return d.p[s.t].v[0][2] + d.p[s.b].v[0][2]; };
  Engine.prototype.setUrl = function (s) { return s.u ? this.base + '/pages/' + s.u : ''; };

  /* ---- the sets: every full look, every set with a model lead, and every flat-lay set (two limestone flats; white vendor flats never). ---- */
  Engine.prototype.build = function () {
    var d = this.d, out = [];
    d.L.forEach(function (s) { if (s.img) out.push({ s: s, kind: 'look', a: s.a, o: s.o, k: s.k, lead: s.img }); });
    d.S.forEach(function (s) {
      var t = d.p[s.t], b = d.p[s.b];
      if (s.m) out.push({ s: s, kind: 'set', a: s.a, o: s.o, k: s.k, lead: s.m });
      else if (t.f && b.f && !t.w && !b.w) out.push({ s: s, kind: 'flat', a: s.a, o: s.o, k: s.k, lead: '' });   /* flat-lay only: two limestone flats, no vendor white, no model needed */
    });
    return out;
  };
  /* Order (Bruce): full looks FIRST, then the rest. Tier 1 = looks + sets with a model lead (looks lead inside each audience); tier 2 = the flat-lay sets.
     Audiences are interleaved inside each tier so no screen is one-sided; one audience selected keeps tier 1 then tier 2. */
  Engine.prototype.ordered = function (list, seg) {
    function tier(items) {
      var by = { her: [], him: [], unisex: [] };
      items.forEach(function (x) { (by[x.a] || (by[x.a] = [])).push(x); });
      SEGS.forEach(function (a) {
        by[a] = spread(by[a].filter(function (x) { return x.kind === 'look'; })).concat(spread(by[a].filter(function (x) { return x.kind === 'set'; })), spread(by[a].filter(function (x) { return x.kind === 'flat'; })));
      });
      return by;
    }
    function weave(by) {
      var out = [], r = 0, more = true;
      while (more) { more = false; for (var i = 0; i < SEGS.length; i++) { var x = by[SEGS[i]][r]; if (x) { out.push(x); more = true; } } r++; }
      return out;
    }
    var t1 = tier(list.filter(function (x) { return x.kind !== 'flat'; })), t2 = tier(list.filter(function (x) { return x.kind === 'flat'; }));
    if (seg && t1[seg]) return t1[seg].concat(t2[seg]);
    return weave(t1).concat(weave(t2));
  };

  /* ---- cards: one system. 3:4 model first; the limestone pair of flats fades in on hover. ---- */
  Engine.prototype.flatImg = function (p, sizes, cls, eager) {
    if (!p.f) return '';
    return '<img class="' + cls + '" src="' + esc(this.src(p.f, 540)) + '" srcset="' + esc(this.srcset(p.f, [300, 450, 640, 900])) + '" sizes="' + sizes + '" width="640" height="800"' + (eager ? '' : ' loading="lazy"') + ' decoding="async" alt="">';
  };
  Engine.prototype.sizesAttr = function (kind) { return kind === 'rail' ? '(min-width: 990px) 23vw, 58vw' : '(min-width: 990px) 24vw, 49vw'; };
  Engine.prototype.card = function (it, idx, ctx) {
    var d = this.d, s = it.s, t = d.p[s.t], b = d.p[s.b], self = this, eager = idx < 4;
    var sizes = this.sizesAttr(ctx), half = sizes.replace(/(\d+)vw/g, function (m, n) { return Math.round(n * 0.64) + 'vw'; });
    var li = el('li', { 'class': 'ma-se__card' });
    var url = it.kind === 'look' ? this.setUrl(s) : '';
    var duo = (!t.w && !b.w && t.f && b.f) ? '<span class="ma-se__duo" aria-hidden="true">' + this.flatImg(t, half, 'ma-se__duo-t', false) + this.flatImg(b, half, 'ma-se__duo-b', false) + '</span>' : '';
    var label = s.dn + ', ' + t.n + ' in ' + t.dc + ' and ' + b.n + ' in ' + b.dc;
    var slides = [];
    if (it.lead) slides.push('<img class="ma-se__look" src="' + esc(this.src(it.lead, 640)) + '" srcset="' + esc(this.srcset(it.lead, [360, 540, 720, 960])) + '" sizes="' + sizes + '" width="720" height="960"' + (eager ? '' : ' loading="lazy"') + ' decoding="async" alt="' + esc(label + (it.kind === 'look' ? ', worn together' : ', shown on the model')) + '">');
    if (duo) slides.push(duo.replace('aria-hidden="true"', 'role="img" aria-label="' + esc(t.n + ' in ' + t.dc + ' and ' + b.n + ' in ' + b.dc + ', laid flat') + '"'));
    var inner = '<span class="ma-se__media' + (it.lead ? '' : ' is-flat') + '"><span class="ma-se__track">' + slides.map(function (h) { return '<span class="ma-se__slide">' + h + '</span>'; }).join('') + '</span>' +
      (slides.length > 1 ? '<span class="ma-se__dots" aria-hidden="true"><i class="is-on"></i><i></i></span>' : '') + '</span>' +
      '<span class="ma-se__meta"><span class="ma-se__name">' + esc(s.dn) + '</span><span class="ma-se__price">' + this.money(this.price(s)) + ' for both</span></span>';
    if (url) {
      li.innerHTML = '<a class="ma-se__link" href="' + esc(url) + '" aria-label="' + esc(label + ', ' + this.money(this.price(s)) + ' for both') + '">' + inner + '</a>';
    } else {
      li.innerHTML = '<button type="button" class="ma-se__link" aria-haspopup="dialog" aria-label="' + esc('Shop the set: ' + label + ', ' + this.money(this.price(s)) + ' for both') + '">' + inner + '</button>';
      li.querySelector('button').addEventListener('click', function () { self.open(s, it, this); });
    }
    /* ONE CARD CONTRACT (12 Oct 2026): the "+" quick add every product card carries opens the same size sheet. */
    var plusBtn = el('button', { 'class': 'ma-se__plus', 'type': 'button', 'aria-haspopup': 'dialog', 'aria-label': 'Quick add ' + s.dn });
    plusBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';
    plusBtn.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); self.open(s, it, plusBtn); });
    li.appendChild(plusBtn);
    this.carousel(li);
    return li;
  };

  /* swipe on phones (the second slide is the pair of flats), the same scroll on hover for fine pointers; dots follow */
  Engine.prototype.carousel = function (li) {
    var track = li.querySelector('.ma-se__track'), dots = li.querySelectorAll('.ma-se__dots i');
    if (!track || !dots.length) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      [].forEach.call(dots, function (dd, k) { dd.className = k === i ? 'is-on' : ''; });
    }, { passive: true });
    if (window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      li.addEventListener('mouseenter', function () { track.scrollTo({ left: track.clientWidth, behavior: 'smooth' }); });
      li.addEventListener('mouseleave', function () { track.scrollTo({ left: 0, behavior: 'smooth' }); });
    }
  };

  /* ---- the grid (sets landing, sub-collections, occasion pages) ---- */
  Engine.prototype.renderGrid = function (host, o) {
    var self = this, d = this.d, q = new URLSearchParams(location.search);
    var st = { seg: o.preset || (o.url && SEG[q.get('sa')] ? q.get('sa') : ''), col: (o.url && q.get('c')) || '', occ: o.occ || (o.url && q.get('o')) || '', n: this.page };
    var base = this.items.filter(function (x) { return !o.occ || x.o === o.occ; });
    function inSeg(x) { return !st.seg || x.a === st.seg; }
    var cols = {}, occs = {};
    function facets() {
      cols = {}; occs = {};
      base.filter(inSeg).forEach(function (x) { cols[x.k] = 1; occs[x.o] = 1; });
    }
    host.innerHTML = '';
    var bar = el('div', { 'class': 'ma-se__bar' }), chips = el('div', { 'class': 'ma-se__chips', role: 'group', 'aria-label': 'Show sets for' });
    var frow = el('div', { 'class': 'ma-se__chips ma-se__chips--f', role: 'group', 'aria-label': 'Filter sets' });
    var status = el('p', { 'class': 'ma-se__status', role: 'status', 'aria-live': 'polite' });
    var grid = el('ul', { 'class': 'ma-se__grid', role: 'list', 'data-se-grid': '' });
    var more = el('div', { 'class': 'ma-se__more' }, '<button type="button" class="ma-btn ma-btn--ghost" hidden>Show more</button>');
    bar.appendChild(chips); bar.appendChild(frow);
    host.appendChild(bar); host.appendChild(status); host.appendChild(grid); host.appendChild(more);
    var mbtn = more.firstChild;
    function segChip(k, label) {
      var on = st.seg === k;
      var href = k ? self.base + '/collections/sets-' + k : self.base + '/collections/sets';
      if (o.occ) return '<button type="button" class="ds-chip' + (on ? ' is-active' : '') + '" data-seg="' + k + '" aria-pressed="' + on + '">' + label + '</button>';
      return '<a class="ds-chip' + (on ? ' is-active' : '') + '" href="' + href + '" data-seg="' + k + '"' + (on ? ' aria-current="true"' : '') + '>' + label + '</a>';
    }
    function drawChips() {
      var all = base, vis = { '': true };
      SEGS.forEach(function (a) { vis[a] = all.some(function (x) { return x.a === a; }); });
      chips.innerHTML = [['', 'All'], ['her', 'Her'], ['him', 'Him'], ['unisex', 'Unisex']].filter(function (c) { return vis[c[0]]; }).map(function (c) { return segChip(c[0], c[1]); }).join('');
      facets();
      var h = '';
      Object.keys(DOT).filter(function (c) { return cols[c]; }).forEach(function (c) {
        var on = st.col === c;
        h += '<button type="button" class="ds-chip ma-se__cc' + (on ? ' is-active' : '') + '" data-col="' + c + '" aria-pressed="' + on + '"><i style="--c:' + DOT[c] + '"></i>' + c + '</button>';
      });
      if (!o.occ) {
        ['Lounge', 'Weekend', 'Travel', 'Court', 'Studio', 'Resort'].filter(function (c) { return occs[c]; }).forEach(function (c) {
          var on = st.occ === c;
          h += '<button type="button" class="ds-chip' + (on ? ' is-active' : '') + '" data-occ="' + c + '" aria-pressed="' + on + '">' + c + '</button>';
        });
      }
      if (st.col || (st.occ && !o.occ)) h += '<button type="button" class="ds-link ma-se__clear" data-clear>Clear</button>';
      frow.innerHTML = h; frow.hidden = !h;
    }
    function list() {
      return self.ordered(base.filter(function (x) { return inSeg(x) && (!st.col || x.k === st.col) && (!st.occ || x.o === st.occ); }), st.seg);
    }
    function draw(keepFocus) {
      var L = list(), shown = Math.min(L.length, st.n);
      grid.innerHTML = '';
      var frag = document.createDocumentFragment();
      for (var i = 0; i < shown; i++) frag.appendChild(self.card(L[i], i, 'grid'));
      grid.appendChild(frag);
      if (!L.length) grid.innerHTML = '<li class="ma-se__empty">No sets match those filters. <button type="button" class="ds-link" data-clear>Clear filters</button></li>';
      mbtn.hidden = shown >= L.length;
      mbtn.textContent = 'Show more';
      status.textContent = L.length ? 'Showing ' + shown + ' of ' + L.length + ' sets' : 'No sets match those filters';
      status.className = 'ma-se__status';
    }
    function url() {
      if (!o.url || o.locked) return;
      var p = new URLSearchParams();
      if (st.seg) p.set('sa', st.seg); if (st.col) p.set('c', st.col); if (st.occ) p.set('o', st.occ);
      var s = p.toString();
      try { history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash); } catch (e) {}
    }
    host.addEventListener('click', function (e) {
      var t = e.target.closest('[data-seg],[data-col],[data-occ],[data-clear]');
      if (!t || !host.contains(t)) return;
      if (t.hasAttribute('data-seg')) {
        if (!o.occ && (o.locked || e.metaKey || e.ctrlKey || e.shiftKey)) return;       /* sub-collection pages navigate; elsewhere filter in place */
        e.preventDefault();
        st.seg = t.getAttribute('data-seg');
        if (st.col && !base.some(function (x) { return inSeg(x) && x.k === st.col; })) st.col = '';
        if (st.occ && !o.occ && !base.some(function (x) { return inSeg(x) && x.o === st.occ; })) st.occ = '';
      } else if (t.hasAttribute('data-col')) { st.col = st.col === t.getAttribute('data-col') ? '' : t.getAttribute('data-col'); }
      else if (t.hasAttribute('data-occ')) { st.occ = st.occ === t.getAttribute('data-occ') ? '' : t.getAttribute('data-occ'); }
      else { st.col = ''; if (!o.occ) st.occ = ''; }
      st.n = self.page; drawChips(); draw(); url();
    });
    mbtn.addEventListener('click', function () {
      var before = st.n; st.n += self.page; draw();
      var f = grid.children[before]; if (f) { var a = f.querySelector('a,button'); if (a) a.focus({ preventScroll: true }); }
    });
    drawChips(); draw();
  };

  /* ---- home rails ---- */
  Engine.prototype.renderRail = function () {
    var self = this, grid = this.root.querySelector('[data-se-rail]'), n = this.limit, pre = this.root.dataset.preset;
    var looks = this.mode === 'rail-looks';
    var list = this.items.filter(function (x) { return (!pre || x.a === pre); });
    var first = this.ordered(list.filter(function (x) { return looks ? x.kind === 'look' : x.kind !== 'look'; }), pre);
    var out = first.length >= n ? first : first.concat(this.ordered(list.filter(function (x) { return looks ? x.kind !== 'look' : x.kind === 'look'; }), pre));
    grid.innerHTML = '';
    out.slice(0, n).forEach(function (it, i) { grid.appendChild(self.card(it, i, 'rail')); });
    if (window.MaPop && MaPop.scan) MaPop.scan(grid);
  };

  /* ---- set page ---- */
  Engine.prototype.renderSet = function () {
    var self = this, d = this.d, qs = new URLSearchParams(location.search).get('set'), h = (qs ? 'preview-' + qs : (this.root.dataset.handle || '')).toLowerCase(), s = null, kind = 'set';
    d.L.forEach(function (x) { if (!s && h.slice(-(x.i.length + 1)) === '-' + x.i.toLowerCase()) { s = x; kind = 'look'; } });
    if (!s) d.S.forEach(function (x) { if (!s && h.slice(-(x.i.length + 1)) === '-' + x.i.toLowerCase()) s = x; });
    var occ = (h.match(/^(?:sets|preview)-(lounge|travel|weekend|court|studio|resort)$/) || [])[1];
    var gal = this.root.querySelector('[data-sp-gal]'), buy = this.root.querySelector('[data-sp-buy]');
    if (s) {
      var t = d.p[s.t], b = d.p[s.b], imgs = [];
      var lead = kind === 'look' ? s.img : s.m;
      if (lead) imgs.push([lead, s.dn + ': ' + t.n + ' in ' + t.dc + ' with ' + b.n + ' in ' + b.dc + (kind === 'look' ? ', worn together' : ', shown on the model'), 'ma-se__look']);
      [t, b].forEach(function (p) { if (p.f && !p.w) imgs.push([p.f, p.n + ' in ' + p.dc + ', laid flat', 'ma-se__flat']); });
      gal.innerHTML = '<div class="ma-sp__track">' + imgs.map(function (x, i) { return '<figure class="ma-sp__fig"><img class="' + x[2] + '" src="' + esc(self.src(x[0], 900)) + '" srcset="' + esc(self.srcset(x[0], [480, 720, 960, 1280])) + '" sizes="(min-width: 990px) 29vw, 100vw" width="960" height="1280"' + (i ? ' loading="lazy"' : ' fetchpriority="high"') + ' alt="' + esc(x[1]) + '"></figure>'; }).join('') + '</div>';
      buy.innerHTML = '<p class="ma-sp__price">' + this.money(this.price(s)) + ' <span>for both pieces</span></p>' + this.buyHTML(s);
      this.bindBuy(buy, s, null);
      this.renderShoes(s);
      /* related: same audience, model-led only, one lead image each, never this set; sharing a piece first, then the same colour family */
      var seen = {}; seen[lead] = 1;
      var pool = this.items.filter(function (x) { var key = x.lead || x.s.i; return x.s !== s && x.a === s.a && !seen[key] && (seen[key] = 1); });
      pool = pool.filter(function (x) { return x.kind !== 'flat'; }).concat(pool.filter(function (x) { return x.kind === 'flat'; }));
      function rk(x) { return (x.kind === 'flat' ? 3 : 0) + ((x.s.t === s.t || x.s.b === s.b) ? 0 : x.k === s.k ? 1 : 2); }
      var rel = pool.map(function (x, i) { return [rk(x), i, x]; }).sort(function (p1, p2) { return p1[0] - p2[0] || p1[1] - p2[1]; }).slice(0, 8).map(function (z) { return z[2]; }), rail = this.root.querySelector('[data-sp-rail]');
      if (rail) { rail.innerHTML = ''; rel.forEach(function (x, i) { rail.appendChild(self.card(x, i + 2, 'rail')); }); if (!rel.length) rail.closest('[data-sp-related]').hidden = true; if (window.MaPop && MaPop.scan) MaPop.scan(rail); }
    } else if (occ) {
      gal.hidden = true; gal.parentNode.classList.add('ma-sp--text');
      var rl = this.root.querySelector('[data-sp-related]'); if (rl) rl.hidden = true;
      var cl = this.root.querySelector('[data-sp-ctl]'); if (cl) cl.hidden = true;
      var host = this.root.querySelector('[data-sp-occ]');
      this.renderGrid(host, { occ: occ.charAt(0).toUpperCase() + occ.slice(1), url: false });
    } else {
      gal.innerHTML = ''; buy.innerHTML = '<p>This set is no longer available. <a href="' + this.base + '/collections/sets">See every set</a>.</p>';
    }
  };

  /* Complete the look: three shoes chosen for this outfit. A true pair on limestone leads (our own created flat, never a vendor image); the on-model shot is the hover. */
  Engine.prototype.renderShoes = function (s) {
    var self = this, d = this.d, box = this.root.querySelector('[data-sp-ctl]');
    if (!box) return;
    var ids = (s.sh || []).filter(function (i) { return d.H && d.H[i]; });
    if (!ids.length) { box.hidden = true; return; }
    var grid = box.querySelector('[data-sp-shoes]'); grid.innerHTML = '';
    ids.forEach(function (i, k) {
      var h = d.H[i], url = self.base + '/products/' + h.h + '?variant=' + h.v;
      var li = el('li', { 'class': 'ma-se__card ma-se__card--shoe' });
      li.innerHTML = '<a class="ma-se__link" href="' + esc(url) + '" aria-label="' + esc(h.n + ' in ' + h.c + ', ' + self.money(h.p)) + '"><span class="ma-se__media"><span class="ma-se__track">' +
        '<span class="ma-se__slide"><img class="ma-se__flat ma-se__shoe" src="' + esc(self.src(h.f, 540)) + '" srcset="' + esc(self.srcset(h.f, [300, 450, 640, 900])) + '" sizes="' + self.sizesAttr('rail') + '" width="640" height="853" loading="lazy" decoding="async" alt="' + esc(h.n + ' in ' + h.c + ', a matching pair') + '"></span>' +
        '<span class="ma-se__slide"><img class="ma-se__look ma-se__shoe-model" src="' + esc(self.src(h.mo, 540)) + '" srcset="' + esc(self.srcset(h.mo, [300, 450, 640, 900])) + '" sizes="' + self.sizesAttr('rail') + '" width="640" height="853" loading="lazy" decoding="async" alt="' + esc(h.n + ' in ' + h.c + ', worn') + '"></span></span>' +
        '<span class="ma-se__dots" aria-hidden="true"><i class="is-on"></i><i></i></span></span>' +
        '<span class="ma-se__meta"><span class="ma-se__name">' + esc(h.n) + '</span><span class="ma-se__price">' + esc(h.c) + ' · ' + self.money(h.p) + '</span></span></a>';
      self.carousel(li);
      grid.appendChild(li);
    });
    box.hidden = false;
    if (window.MaPop && MaPop.scan) MaPop.scan(grid);
  };

  /* ---- buy block: a size per piece (chips, never native selects), Add both pieces, the honest Dress the Set maths ---- */
  Engine.prototype.buyHTML = function (s) {
    var self = this, d = this.d, pieces = [d.p[s.t], d.p[s.b]], html = '<div class="ma-se__qv">', want = this.remembered();
    pieces.forEach(function (p, i) {
      var sz = p.v.map(function (v) { return '<button type="button" class="ma-se__size" data-i="' + i + '" data-id="' + v[0] + '" data-sz="' + esc(v[1]) + '"' + (v[3] ? '' : ' disabled aria-label="' + esc(v[1]) + ', sold out"') + ' aria-pressed="false">' + esc(v[1]) + '</button>'; }).join('');
      html += '<div class="ma-se__qp" data-piece="' + i + '">' +
        '<a class="ma-se__qimg' + (p.w ? ' is-w' : '') + '" href="' + esc(self.pdp(p, s.a)) + '" tabindex="-1" aria-hidden="true">' + self.flatImg(p, '120px', 'ma-se__qpic', false) + '</a>' +
        '<div class="ma-se__qinfo"><p class="ma-se__qn"><a href="' + esc(self.pdp(p, s.a)) + '">' + esc(p.n) + '</a></p>' +
        '<p class="ma-se__qc">' + esc(p.dc) + ' · <span data-qprice="' + i + '">' + self.money(p.v[0][2]) + '</span></p>' +
        '<div class="ma-se__sizes" role="group" aria-label="' + esc(p.n + ' size') + '">' + sz + '</div></div></div>';
    });
    html += '</div><div class="ma-se__foot"><p class="ma-se__total" data-qtotal-row hidden><span>Both pieces</span> <strong data-qtotal></strong></p>' +
      '<button type="button" class="ma-btn ma-se__add" data-qadd>Add both pieces</button>' +
      '<p class="ma-se__hint" data-qhint>Choose a size for each piece.</p>' +
      '<p class="ma-se__dress" data-qdress>Dress the Set: 15% off both pieces, applied in your bag.</p>' +
      '<p class="ma-se__err" role="alert" data-qerr hidden></p></div>';
    return html;
  };
  Engine.prototype.remembered = function () { try { return JSON.parse(LS.get('ma_se_sizes') || '{}'); } catch (e) { return {}; } };
  Engine.prototype.bindBuy = function (box, s, opener) {
    var self = this, mem = this.remembered();
    this.cur = { s: s, sel: [null, null], opener: opener }; this.buy = box;
    [].forEach.call(box.querySelectorAll('.ma-se__size'), function (b) {
      b.addEventListener('click', function () { self.pick(+b.dataset.i, +b.dataset.id, b.dataset.sz, true); });
    });
    /* a size you chose before on this device comes back pre-selected, when it is in stock */
    [0, 1].forEach(function (i) {
      var role = i === 0 ? 'top' : 'bottom', w = mem[role];
      if (!w) return;
      var b = box.querySelector('.ma-se__size[data-i="' + i + '"][data-sz="' + w + '"]:not([disabled])');
      if (b) self.pick(i, +b.dataset.id, w, false);
    });
    box.querySelector('[data-qadd]').addEventListener('click', function () { self.add(); });
    this.update();
  };
  Engine.prototype.pick = function (i, id, sz, save) {
    this.cur.sel[i] = id;
    [].forEach.call(this.buy.querySelectorAll('.ma-se__size[data-i="' + i + '"]'), function (x) { x.setAttribute('aria-pressed', String(+x.dataset.id === id)); });
    if (save) { var m = this.remembered(); m[i === 0 ? 'top' : 'bottom'] = sz; LS.set('ma_se_sizes', JSON.stringify(m)); }
    this.update();
  };
  Engine.prototype.variant = function (i) { var p = this.d.p[i === 0 ? this.cur.s.t : this.cur.s.b], id = this.cur.sel[i]; for (var k = 0; k < p.v.length; k++) if (p.v[k][0] === id) return p.v[k]; return null; };
  Engine.prototype.update = function () {
    var a = this.variant(0), b = this.variant(1), self = this;
    [a, b].forEach(function (v, i) { if (v) self.buy.querySelector('[data-qprice="' + i + '"]').textContent = self.money(v[2]); });
    var ok = !!(a && b), dress = this.buy.querySelector('[data-qdress]'), tot = this.buy.querySelector('[data-qtotal]'), row = this.buy.querySelector('[data-qtotal-row]'), hint = this.buy.querySelector('[data-qhint]');
    var names = this.d.p, s = this.cur.s;
    if (ok) {
      /* same per-line rounding as snippets/ma-set-choice.liquid (live automatic Dress the Set discount: 15% off two pieces, applied in the bag) */
      var dt = Math.round(a[2] * 85 / 100) + Math.round(b[2] * 85 / 100);
      tot.innerHTML = '<s>' + this.money(a[2] + b[2]) + '</s> ' + this.money(dt);
      row.hidden = false;
      dress.textContent = 'Dress the Set: 15% off both pieces. You save ' + this.money(a[2] + b[2] - dt) + ', applied in your bag.';
      hint.hidden = true;
    } else {
      row.hidden = true;
      dress.textContent = 'Dress the Set: 15% off both pieces, applied in your bag.';
      hint.hidden = false;
      hint.textContent = !a && !b ? 'Choose a size for each piece.' : !a ? 'Choose a size for the ' + this.role(0) + '.' : 'Choose a size for the ' + this.role(1) + '.';
    }
    [].forEach.call(this.buy.querySelectorAll('.ma-se__qp'), function (r, i) { r.classList.remove('is-need'); });
  };
  Engine.prototype.role = function (i) { var y = this.cur.s.y; return i === 0 ? ({ bra: 'top', tank: 'top', tee: 'top', hoodie: 'hoodie', sweat: 'sweatshirt', shirt: 'shirt', polo: 'polo' }[y] || 'top') : 'bottoms'; };
  Engine.prototype.add = function () {
    var a = this.variant(0), b = this.variant(1), self = this, btn = this.buy.querySelector('[data-qadd]'), err = this.buy.querySelector('[data-qerr]'), hint = this.buy.querySelector('[data-qhint]');
    if (this.busy) return;
    if (!a || !b) {            /* the button stays navy; it tells you what is missing instead of looking disabled */
      hint.hidden = false; hint.classList.add('is-nudge'); setTimeout(function () { hint.classList.remove('is-nudge'); }, 1400);
      [].forEach.call(this.buy.querySelectorAll('.ma-se__qp'), function (r, i) { r.classList.toggle('is-need', !(i === 0 ? a : b)); });
      var need = this.buy.querySelector('.ma-se__qp.is-need'); if (need && need.scrollIntoView) need.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    this.busy = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…'; err.hidden = true;
    fetch(this.root.dataset.add, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: a[0], quantity: 1 }, { id: b[0], quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'Could not add both pieces.'); return j; }); })
      .then(function () { location.assign(self.root.dataset.cart); })
      .catch(function (e) { err.textContent = e.message || 'Could not add both pieces.'; err.hidden = false; btn.textContent = 'Add both pieces'; btn.removeAttribute('aria-busy'); self.busy = false; });
  };

  /* ---- quick-shop sheet (flat sets have no page of their own) ---- */
  Engine.prototype.open = function (s, it, opener) {
    var self = this;
    var html = '<div class="ma-se__shead"><img class="ma-se__shero" src="' + esc(this.src(it.lead || this.d.p[s.t].f, 360)) + '" width="360" height="450" alt="">' +
      '<div><p class="ma-se__k">Shop the set</p><h2 class="ma-se__sheet-title" tabindex="-1" id="' + this.sheet.getAttribute('aria-labelledby') + '">' + esc(s.dn) + '</h2>' +
      '<p class="ma-se__sprice">' + this.money(this.price(s)) + ' for both</p></div></div>' + this.buyHTML(s);
    this.body.innerHTML = html;
    this.bindBuy(this.body, s, opener);
    if (!this.sheet.__b) {
      this.sheet.__b = 1;
      this.root.querySelector('[data-se-close]').addEventListener('click', function () { self.close(); });
      this.sheet.addEventListener('click', function (e) { if (e.target === self.sheet) self.close(); });
      this.sheet.addEventListener('close', function () { document.documentElement.classList.remove('ma-se-lock'); if (self.cur && self.cur.opener) self.cur.opener.focus({ preventScroll: true }); });
      if (window.MaPop && MaPop.sheet) MaPop.sheet(this.root.querySelector('[data-se-panel]'), { grab: '.ma-se__grip', onClose: function () { self.close(); } });
    }
    if (this.sheet.showModal) this.sheet.showModal(); else this.sheet.setAttribute('open', '');
    document.documentElement.classList.add('ma-se-lock');
    var first = this.body.querySelector('.ma-se__sheet-title'); if (first) first.focus({ preventScroll: true });
  };
  Engine.prototype.close = function () { if (this.sheet.close) this.sheet.close(); else this.sheet.removeAttribute('open'); };

  function boot() { [].forEach.call(document.querySelectorAll('[data-ma-sets-engine]'), function (r) { if (!r.__se) { r.__se = 1; new Engine(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
}());
